const getThumbnailImage = (webcastData, imageText?:string) => {

  if (webcastData.links === undefined || webcastData.links.filter(linkObj => linkObj.title === (imageText === 'companyLogo' ? 'logo' : 'preview')).length < 1) {

    return undefined

  }

  const { href } = webcastData.links.filter(linkObj => linkObj.title === ((imageText && imageText === 'companyLogo') ? 'logo' :'preview'))[0]
  return href

}

const getThumbnailObject = (webcastData, imageText?: string) => {

  const href = getThumbnailImage(webcastData, imageText)
  if (!href) {

    return undefined

  }
  return { image: href, text: imageText || 'Webcast preview' }

}
export { getThumbnailObject, getThumbnailImage }
